<template>
  <div v-if="messangerId" :style="{display: display}" data-messanger="facebook">
    <!-- Messenger 채팅 플러그인 Code -->
    <div id="fb-root"></div>
    <!-- Your 채팅 플러그인 code -->
    <div id="fb-customer-chat" class="fb-customerchat"></div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  computed: {
    thirdpartyInfo () {
      const thirdparty = this.$store.getters['thirdparty/getThirdparty']
      const facebookMessanger = thirdparty && thirdparty.find(x => x.id === 'facebookmessanger')
      return facebookMessanger
    },
    isMain () {
      const setting = this.$store.getters['common/getSetting']
      const mainRoute = this.$route.name === 'main'
      const mainPage = this.$route.name === 'page' && this.$route.params.id === setting.main.page
      return mainRoute || mainPage
    },
    display () {
      const isMain = this.isMain
      const mainOnly = this.thirdpartyInfo.mainOnly
      return mainOnly
        ? isMain ? '' : 'none'
        : ''
    },
    messangerId () {
      const facebookMessanger = this.thirdpartyInfo
      const facebookId = facebookMessanger && facebookMessanger.active && facebookMessanger.messangerId
      return facebookId ? regExp.replaceAllEmpty(facebookId).replace('m.me/', '') : null
    }
  },
  mounted () {
    const chatbox = document.getElementById('fb-customer-chat')
    if (chatbox) {
      chatbox.setAttribute('page_id', this.messangerId)
      chatbox.setAttribute('attribution', 'biz_inbox')
      this.init()
    }
  },
  methods: {
    init () {
      window.fbAsyncInit = function () {
        FB.init({
          xfbml: true,
          version: 'v15.0',
          whitelisted_domains: [
            'https://edit.istay.io',
            'https://edit-dev.istay.io'
          ]
        })
      };

      (function (d, s, id) {
        var js
        var fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    }
  }
}
</script>
